export default "__VITE_ASSET__CM50BGpd__"